import React from 'react';

import { LazyBreadcrumb } from '@europrocurement/flexy-components';

import WidgetsFrame from './WidgetsFrame/WidgetsFrame';

const Accueil = function () {
    return (
        <>
            <LazyBreadcrumb path={[{ path: 'Accueil', link: '/accueil' }, 'Dashboard']} />

            <WidgetsFrame />
        </>
    );
};
export default Accueil;
